import DigitPasswordCircle from '../assets/fonts/DigitPasswordCircle.ttf';
import DigitPasswordSquare from '../assets/fonts/DigitPasswordSquare.ttf';
// fonts
import SantanderHeadlineBold from '../assets/fonts/SantanderHeadline-Bold.ttf';
import SantanderHeadlineLight from '../assets/fonts/SantanderHeadline-Light.ttf';
import SantanderHeadlineRegular from '../assets/fonts/SantanderHeadline-Regular.ttf';
import SantanderMicroTextBold from '../assets/fonts/SantanderMicroText-Bold.ttf';
import SantanderMicroTextRegular from '../assets/fonts/SantanderMicroText-Regular.ttf';
import SantanderMicroTextSemiBold from '../assets/fonts/SantanderMicroText-SemiBold.ttf';
export const FONTS_RELOADED_FLAME_GLOBAL_STYLES = `
  @font-face {
    font-family: 'Santander Headline';
    font-weight: 700;
    src: url(${SantanderHeadlineBold}) format('truetype');
  }

  @font-face {
    font-family: 'Santander Headline';
    font-weight: 400;
    src: url(${SantanderHeadlineRegular}) format('truetype');
  }

  @font-face {
    font-family: 'Santander Headline';
    font-weight: 300;
    src: url(${SantanderHeadlineLight}) format('truetype');
  }

  @font-face {
    font-family: 'Santander MicroText';
    font-weight: 700;
    src: url(${SantanderMicroTextBold}) format('truetype');
  }

  @font-face {
    font-family: 'Santander MicroText';
    font-weight: 600;
    src: url(${SantanderMicroTextSemiBold}) format('truetype');
  }

  @font-face {
    font-family: 'Santander MicroText';
    font-weight: 400;
    src: url(${SantanderMicroTextRegular}) format('truetype');
  }

  @font-face {
    font-family: 'DigitPasswordCircle';
    font-weight: 400;
    src: url(${DigitPasswordCircle}) format('truetype');
  }

  @font-face {
    font-family: 'DigitPasswordSquare';
    font-weight: 400;
    src: url(${DigitPasswordSquare}) format('truetype');
  }
`;
//# sourceMappingURL=fonts.js.map